"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyDesignListApi = companyDesignListApi;
exports.companyappAutoListApi = companyappAutoListApi;
exports.copyDesignApi = copyDesignApi;
exports.customersListApi = customersListApi;
exports.deleteApi = deleteApi;
exports.disableApi = disableApi;
exports.getDetailApi = getDetailApi;
exports.manageDeleteApi = manageDeleteApi;
exports.manageRelateApi = manageRelateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 复制装修页面
 */
function copyDesignApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/company-design/copyDesign",
    method: 'GET',
    params: params
  });
}

/**
 * 列表的删除
 */
function deleteApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/company-design/delete",
    method: 'GET',
    params: params
  });
}

/**
 * 列表的禁用
 */
function disableApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/company-design/disable",
    method: 'GET',
    params: params
  });
}

/**
 * 装修管理引用的删除
 */
function manageDeleteApi(params) {
  return (0, _request.default)({
    url: "/admin/company-design/removeRelate",
    method: 'GET',
    params: params
  });
}

/**
 * 装修管理引用
 */
function manageRelateApi(data) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/company-design/manageRelate",
    method: 'POST',
    data: data
  });
}

/**
 * 小程序列表自动补全
 */
function companyappAutoListApi(params) {
  // return request({
  //     url: `/admin/companyapp/autoList`,
  //     method: 'GET',
  //     params,
  // })

  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/company-app/autoList',
    method: 'get',
    params: params
  });
}

/**
 * 装修管理列表
 */
function companyDesignListApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/company-design/list",
    method: 'GET',
    params: params
  });
}

/**
 * 查询客户下拉列表
 * @param {*} id
 * @returns
 */
function customersListApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/options",
    method: 'GET',
    params: params
  });
}

/**
 * 详情
 */
function getDetailApi(params) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/company-design/getDetail',
    method: 'GET',
    params: params
  });
}